import classes from "./ProtocolContentView.module.css"
import {TextInput, Box, BoxProps} from "@mantine/core";
import {forwardRef} from "react";
import {IProtocolDefinition} from "./types/protocolDefinitions";

interface ProtocolContentViewProps extends BoxProps {
    protocol: IProtocolDefinition,
    onChange: (protocol: IProtocolDefinition) => void
}

export const ProtocolContentView = forwardRef<HTMLDivElement, ProtocolContentViewProps>(({
                                                                                             protocol,
                                                                                             onChange,
                                                                                             ...others
                                                                                         }, ref) => {
    return (
        <Box ref={ref} {...others} className={classes.root}>
            <Box w={"35em"}>
                <TextInput
                    className={classes.title}
                    data-testid={"input-protocol-title"}
                    label={"Protocol Name"}
                    mt={"20px"}
                    ta={"center"}
                    fw={"bold"}
                    required={true}
                    minLength={1}
                    error={!protocol.name ? "Invalid name, length must be at least 1" : ""}
                    value={protocol.name}
                    onChange={(ev) => {
                        return onChange({...protocol, name: ev.currentTarget.value})
                    }}
                />
            </Box>
        </Box>
    )
})
